<div class="grid-container">
    <div class="grid-item top-button">
        <div class="content">
            <button mat-stroked-button class="button edit dataset">Edit Dataset</button>
            <button mat-stroked-button class="button edit fixture">Edit Fixture</button>
        </div>
    </div>
    <div class="grid-item overview left">
        <div class="content">
            <mat-card class="card">
                <mat-card-header>
                    <mat-card-title class="header">Analytics Overview</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="above-threshold">
                        <img src="assets/images/sample.png" alt="overview" class="image">
                        <p class="title">Above Threshold</p>
                    </div>
                    <div class="search-overwrites">
                        <p class="title">Search and Overides</p>
                        <app-run-experiment></app-run-experiment>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="grid-item version right">
        <div class="content">
            <mat-card class="card">
                <mat-card-header>
                    <mat-card-title class="header">Default Versions</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="grid-item insight right">
        <div class="content">
            <mat-card class="card">
                <mat-card-header>
                    <mat-card-title class="header">Data Insights</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="grid-item list right">
        <div class="content">
            <mat-card class="card">
                <mat-card-header>
                    <mat-card-title class="header">Experiment Run List</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>